import get from 'lodash.get';

const getYolacomUrl = (rootState) => get(rootState, 'config.service.common["yolacom"].url', null);

export default getYolacomUrl;
